import $ from 'jquery';

$('.office #user_login').attr( 'placeholder', 'Логін:' );
$('.office #user_pass').attr( 'placeholder', 'Пароль:' );

$(document).ready(function () {
    if (window.location.href.indexOf("failed") > -1) {
        $('.office__block').prepend('<h4 class="office__title">Невірно вказаний пароль або логін</h4>')
    }
});

let url_string = window.location.href;
let url = new URL(url_string);
let search = url.searchParams.get("q");

if (search) {
  if (search === 'office_career') {
    $('.office__career').show()
  } else {
    $('.office__psychologist').show()
  }
}
